import { Chip } from "@mui/material";

import type { TenantStatusName } from "./tenant-card";

interface TenantStatusChipProps {
	readonly tenantStatus: TenantStatusName;
}
export const getTenantStatusLabel = (tenantStatus: TenantStatusName) => {
	switch (tenantStatus) {
		case "Internal":
			return "Internal";
		case "NonOperating":
			return "Non-Operating";
		case "Decommissioned":
			return "Decommissioned";
		case "Operating":
		default:
			return "Operating";
	}
};
export const getTenantStatusColor = (tenantStatus: TenantStatusName) => {
	switch (tenantStatus) {
		case "Internal":
			return "slateBlue";
		case "NonOperating":
			return "default";
		case "Decommissioned":
			return "default";
		case "Operating":
		default:
			return "success";
	}
};
export const TenantStatusChip: React.FC<TenantStatusChipProps> = ({ tenantStatus }) => {
	const tenantLabel = getTenantStatusLabel(tenantStatus);
	const tenantColor = getTenantStatusColor(tenantStatus);

	return <Chip label={tenantLabel} size="small" color={tenantColor} />;
};
